import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Routes from './Routes/Routes';
import configureStore, { history } from './reduxStore';
import trackingUtils from './utils/trackingUtils';

const render = () => {
    trackingUtils.initializeGoogleAnalytics();
    ReactDOM.render(
        <Provider store={configureStore()}>
            <Routes history={history} />
        </Provider>,
        document.getElementById('root'),
    );
};

render();
